/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cognito_identity_pool_id": "eu-west-3:6be15283-3f22-414b-a380-2e406f92fd24",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_D3BLyYKQJ",
    "aws_user_pools_web_client_id": "3iuo9hnsl7qt969c7dvkjr8nkr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://gunji3kpunghnfftfyyqjsfbni.appsync-api.eu-west-3.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-3",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-wo4p4o5e7jgs3gv2bhmy3rkn7q",
    "aws_cloud_logic_custom": [
        {
            "name": "emailApi",
            "endpoint": "https://7pgv7ck7r9.execute-api.eu-west-3.amazonaws.com/dev",
            "region": "eu-west-3"
        }
    ],
    "aws_user_files_s3_bucket": "projetrestocommandeproduit507d2-dev",
    "aws_user_files_s3_bucket_region": "eu-west-3"
};


export default awsmobile;
